import { Store } from '@tencent/workbench-core';
import { ServiceNames } from '../../constants/service-name.js';
import { setCustomMetadata } from './ui-decorator-utils.js';
import { Use } from './use.js';

/**
 * Titlebar 装饰器，可以向 TitlebarService 里绑定回调类型的 config 信息。
 *
 * @remarks
 *
 * 示例代码：
 *
 *
 * @param name - UI 配置的名称
 * @param callbackName - 触发方法
 * @decorator
 * @public
 */
function Titlebar(name, callbackName, customMetadata) {
    return Store.decorate((store) => {
        var _a;
        const points = (_a = store.get('points')) !== null && _a !== void 0 ? _a : [];
        const point = {
            from: ServiceNames.TITLEBAR, name, trigger: callbackName, path: [],
        };
        store.set('points', points.concat([point]));
        setCustomMetadata(point, store, customMetadata);
        return Use('Titlebar');
    });
}

export { Titlebar };
//# sourceMappingURL=titlebar.js.map
